import React from "react";
import { SizeSelect } from "./SizeSelect";
import { SizeNumber } from "./SizeNumber";
import { I18N } from "oc-I18N";
import { MASSE } from "../torkonfigurator/Masse";

type SizeInputProps = {
  axis: string;
  dataInputKey?: string;
  value: number;
  setter: (value: number) => void;
  min: number;
  max: number;
  disabled?: boolean;
  className?: string;
  onFocus?: (e: React.FocusEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  decimals?: number;
  unit?: string;
  step?: number;
  conversionFactor?: number;
  ariaLabel?: string;
};

export function SizeInput({
  axis,
  dataInputKey,
  value,
  setter,
  min,
  max,
  disabled = false,
  className,
  onFocus,
  onBlur,
  decimals = 2,
  unit = "m",
  step,
  conversionFactor = 1,
  ariaLabel,
}: SizeInputProps) {
  const agt = APP.arrangement;

  if (agt.selectedObjects[0]?.hasSchrittweite?.(axis)) {
    // Im Torkonfigurator gibt es auch Eingaben für Lichte Weite. Hier darf nicht einfach nur die
    // Schrittweite für axis=x genommen werden, sondern es muss der LichteWeiteZusatz eingerechnet werden.
    let extra = 0;
    if (APP.isTorkonfigurator) {
      const konf = APP.arrangement.konfiguration;
      if (dataInputKey == MASSE.LichteWeite) {
        extra = konf.getLichteWeiteZusatz();
      } else if (dataInputKey == MASSE.LichteWeiteEinzeltor) {
        extra = konf.getLichteWeiteZusatz(konf.currentElementEinzeltor);
      }
    }

    const optionen = agt.selectedObjects[0].getSchrittweitenOptionen(axis).map((number) => ({
      value: (number + extra) * conversionFactor,
      label: I18N.formatFloat((number + extra) * conversionFactor, decimals) + unit,
    }));

    return (
      <SizeSelect
        value={value * conversionFactor}
        setter={(value) => setter(value / conversionFactor)}
        optionen={optionen}
        dataInputKey={dataInputKey}
        ariaLabel={ariaLabel}
      />
    );
  }
  return (
    <SizeNumber
      value={value * conversionFactor}
      setter={(value) => setter(value / conversionFactor)}
      disabled={disabled}
      className={className}
      min={min * conversionFactor}
      max={max * conversionFactor}
      onFocus={onFocus}
      onBlur={onBlur}
      dataInputKey={dataInputKey}
      decimals={decimals}
      unit={unit}
      step={step}
      ariaLabel={ariaLabel}
    />
  );
}
